/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.AccountLimitsResponse, (requestParams: vp.AccountLimitsRequest) => void, () => void];

function useFetchAccountLimits({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.AccountLimitsRequest>();
  const [response, setResponse] = useState<vp.AccountLimitsResponse>({
    ErrorMessage: '',
    Success: false,
    Inbound: {
      Limits: {
        Daily: "",
        Weekly: "",
        Monthly: ""
      },
      RemainingLimits: {
        Daily: "",
        Weekly: "",
        Monthly: ""
      },
    },
    Outbound: {
      Limits: {
        Daily: "",
        Weekly: "",
        Monthly: ""
      },
      RemainingLimits: {
        Daily: "",
        Weekly: "",
        Monthly: ""
      },
    }
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AccountLimitsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchAccountLimits(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AccountLimitsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Inbound: {
          Limits: {
            Daily: "",
            Weekly: "",
            Monthly: ""
          },
          RemainingLimits: {
            Daily: "",
            Weekly: "",
            Monthly: ""
          },
        },
        Outbound: {
          Limits: {
            Daily: "",
            Weekly: "",
            Monthly: ""
          },
          RemainingLimits: {
            Daily: "",
            Weekly: "",
            Monthly: ""
          },
        }
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchAccountLimits);
